import { NewsDetails } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetNewsDetailsResponse } from "../schema/GetNewsDetailsResponse";
import { mapNewsDetails } from "../../mappers/news/newsDetailsMapped";

export const getNewsNewestDetails = async (): Promise<NewsDetails> => {
    const client = ApiClient.getInstance()

    const response = await client.get<GetNewsDetailsResponse>(`news/newest`)

    const mappedResponse = mapNewsDetails(response.data)

    return mappedResponse;
}